<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-12-14 19:56:32
 * @LastEditors: lau
 * @LastEditTime: 2023-03-27 13:48:19
-->
<!-- 车牌校正数据上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
"areaId": "26",
"channelCode": "2KR",
"channelId": "5899",
"channelName": "入口1",
"cmd": "reportToBeAssistedInformation",
"content": {
"assistMessage": "未识别自助进场",
"assistMessageType": "6",
"carNo": "未识别16710157785899000",
"carNoColor": 1,
"carType": "小车",
"enterTime": 1671015777000,
"novipCode": 1,
"parkingCode": "2212141",
"vipName": "临时车",
"vipType": 1
},
"createTime": "20221214190258",
"lockKey": "d73dfa615ca1c7db6f4eb841c561e90684ff43e2",
"msgType": "0",
"msgTypeName": "进车",
"parkCode": "2K",
"parkName": "中心"
},
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报停车场协助信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportToBeAssistedInformation",
                precondition: "不开闸情况",
                fitSystem: "智泊云",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        { info1: 'msgType', info2: '是', info3: 'String', info4: '消息类型0:进车,1:出车' },
                        { info1: 'msgTypeName', info2: '是', info3: 'String', info4: '消息类型名称' },
                        { info1: 'createTime', info2: '是', info3: 'String', info4: '创建时间，yyyyMMddHHmmss' },
                        { info1: 'areaId', info2: '是', info3: 'String', info4: '区域id' },
                        { info1: 'channelCode', info2: '是', info3: 'String', info4: '通道编号' },
                        { info1: 'channelId', info2: '是', info3: 'String', info4: '通道id' },
                        { info1: 'channelName', info2: '是', info3: 'String', info4: '通道名称' },
                        { info1: 'content', info2: '是', info3: 'JSONObject', info4: '内容(当msgType改变， content也会改变) ' },
                        ]
                },
                {
                    titleName: 'content(msgType=0)',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'assistMessage', info2: '是', info3: 'String', info4: '协助信息名称' },
                        { info1: 'assistMessageType', info2: '是', info3: 'String', info4: '协助信息类型' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌' },
                        { info1: 'carNoColor', info2: '否', info3: 'String', info4: '车牌颜色0未定义，1蓝色，2黄色，3白色，4黑色，5绿色' },
                        { info1: 'carType', info2: '否', info3: 'String', info4: '车辆类型' },
                        { info1: 'carTypeInt', info2: '否', info3: 'Integer', info4: '车辆类型0未知，1小车，2大车，3超大车，4中型车' },
                        { info1: 'picTime', info2: '是', info3: 'String', info4: '拍照时间' },
                        { info1: 'novipCode', info2: '是', info3: 'String', info4: '进场说明（<url>参考附录:/Api/appendixData#appendixData_2</url>）' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车流水' },
                        { info1: 'vipName', info2: '否', info3: 'String', info4: 'vip名称' },
                        { info1: 'vipType', info2: '否', info3: 'String', info4: 'vip类型（<url>参考附录:/Api/appendixData#appendixData_2</url>）' },
                        { info1: 'enterImageArray', info2: '是', info3: 'JSONArray', info4: '预进场图片' },
                    ]
                },{
                    titleName: 'enterImageArray',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carImage', info2: '是', info3: 'String', info4: '车身图片' },
                        { info1: 'plateImage', info2: '是', info3: 'String', info4: '车牌图片' },
                    ]
                },{
                    titleName: 'content(msgType=1)',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'assistMessage', info2: '是', info3: 'String', info4: '协助信息名称' },
                        { info1: 'assistMessageType', info2: '是', info3: 'String', info4: '协助信息类型' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌' },
                        { info1: 'carType', info2: '否', info3: 'String', info4: '车辆类型' },
                        { info1: 'carTypeInt', info2: '否', info3: 'Integer', info4: '车辆类型0未知1小车2大车3超大车4中型车' },
                        { info1: 'picTime', info2: '是', info3: 'String', info4: '拍照时间' },
                        { info1: 'enterTime', info2: '是', info3: 'String', info4: '进场时间' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车流水' },
                        { info1: 'enterVipName', info2: '否', info3: 'String', info4: '进场vip名称' },
                        { info1: 'leaveNovipCode', info2: '否', info3: 'Integer', info4: '出场说明（<url>参考附录:/Api/appendixData#appendixData_3</url>）' },
                        { info1: 'leaveImageArray', info2: '是', info3: 'JSONArray', info4: '预离场图片' },
                        { info1: 'shouldValue', info2: '是', info3: 'Decimal', info4: '应缴金额' },
                        { info1: 'leaveVipType', info2: '否', info3: 'Integer', info4: '离场vip类型（<url>参考附录:/Api/appendixData#appendixData_2</url>）' },
                        { info1: 'leaveVipTypeName', info2: '否', info3: 'Integer', info4: '离场vip类型名称' },
                        { info1: 'carNoColor', info2: '否', info3: 'Integer', info4: '离场车牌颜色0未定义，1蓝色，2黄色，3白色，4黑色，5绿色' },

                    ]
                },{
                    titleName: 'leaveImageArray',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carImage', info2: '是', info3: 'String', info4: '车身图片' },
                        { info1: 'plateImage', info2: '是', info3: 'String', info4: '车牌图片' },
                    ]
                }
            ],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [

                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportToBeAssistedInformation.vue